
import { defineComponent } from 'vue';
import AppSignOut from '@/components/AppSignOut.vue';
import MaterialIcon from '@/components/MaterialIcon.vue';

export default defineComponent({
  name: 'AppNavigation',
  components: {
    AppSignOut,
    MaterialIcon
  }
});
